// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:16
import { DictionaryElement_abstract } from './../abstract/SagaSchema/DictionaryElement_abstract';
export class DictionaryElement extends DictionaryElement_abstract {}
